import AutomationError from './AutomationError';
class DispersionNotFinished extends AutomationError {
    constructor(options) {
        super('A previous rent dispersion of this investor is still in progress.', options);
    }
}
export default DispersionNotFinished;
